import axios from 'axios';

// API-URL - dynamisch basierend auf Environment
const API_BASE_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' 
  ? 'http://localhost:8000' 
  : window.location.origin;

// Axios-Konfiguration
const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor
api.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// API-Endpunkte
export const apiService = {
  // Login
  login: async (username, password) => {
    try {
      const response = await api.post('/api/login/', {
        username,
        password,
      });
      return response.data;
    } catch (error) {
      console.error('Fehler beim Login:', error);
      throw error;
    }
  },

  // Home-Daten abrufen
  getHomeData: async () => {
    try {
      const response = await api.get('/api/home-data/');
      return response.data;
    } catch (error) {
      console.error('Fehler beim Abrufen der Home-Daten:', error);
      throw error;
    }
  },

  // Statistik-Übersicht
  getStatsOverview: async () => {
    try {
      const response = await api.get('/api/stats/overview/');
      return response.data;
    } catch (error) {
      console.error('Fehler beim Abrufen der Statistiken:', error);
      throw error;
    }
  },

  // Popups: Geburtstag / Einstand / Satzung
  birthdayRemindLater: async () => {
    try {
      const response = await api.post('/api/birthday-remind-later/');
      return response.data;
    } catch (error) {
      console.error('Fehler bei birthdayRemindLater:', error);
      throw error;
    }
  },
  birthdayAcknowledge: async () => {
    try {
      const response = await api.post('/api/birthday-acknowledge/');
      return response.data;
    } catch (error) {
      console.error('Fehler bei birthdayAcknowledge:', error);
      throw error;
    }
  },
  birthdayTreatRemindLater: async () => {
    try {
      const response = await api.post('/api/birthday-treat-remind-later/');
      return response.data;
    } catch (error) {
      console.error('Fehler bei birthdayTreatRemindLater:', error);
      throw error;
    }
  },
  entryRemindLater: async () => {
    try {
      const response = await api.post('/api/entry-remind-later/');
      return response.data;
    } catch (error) {
      console.error('Fehler bei entryRemindLater:', error);
      throw error;
    }
  },
  getTerms: async () => {
    try {
      const response = await api.get('/api/terms/');
      return response.data;
    } catch (error) {
      console.error('Fehler beim Abrufen der Satzung:', error);
      throw error;
    }
  },
  acceptTerms: async () => {
    try {
      const response = await api.post('/api/accept-terms/');
      return response.data;
    } catch (error) {
      console.error('Fehler beim Akzeptieren der Satzung:', error);
      throw error;
    }
  },
  submitFeedbackTicket: async (payload) => {
    try {
      const response = await api.post('/api/feedback-ticket/', payload);
      return response.data;
    } catch (error) {
      console.error('Fehler beim Erstellen des Feedback-Tickets:', error);
      throw error;
    }
  },

  // Transaktion erstellen
  createTransaction: async (drinkId) => {
    try {
      const response = await api.post('/api/create-transaction/', {
        drink_id: drinkId
      });
      return response.data;
    } catch (error) {
      console.error('Fehler beim Erstellen der Transaktion:', error);
      throw error;
    }
  },

  // Guthaben abrufen
  getBalance: async () => {
    try {
      const response = await api.get('/api/member-balance/');
      return response.data;
    } catch (error) {
      console.error('Fehler beim Abrufen des Guthabens:', error);
      throw error;
    }
  },

  // Logout
  logout: async () => {
    try {
      await api.post('/api/logout/');
    } catch (error) {
      console.error('Fehler beim Logout:', error);
      throw error;
    }
  },

  // Guthaben aufladen
  rechargeCredit: async (amount) => {
    try {
      const response = await api.post('/api/recharge-credit/', {
        amount: amount
      });
      return response;
    } catch (error) {
      console.error('Fehler beim Aufladen des Guthabens:', error);
      throw error;
    }
  },

  // Runde spendieren
  giveRound: async (giftType, message) => {
    try {
      const response = await api.post('/api/give-round/', {
        gift_type: giftType,
        message: message
      });
      return response;
    } catch (error) {
      console.error('Fehler beim Spendieren der Runde:', error);
      throw error;
    }
  },

  // Geschenk beenden
  endRound: async () => {
    try {
      const response = await api.post('/api/end-round/');
      return response;
    } catch (error) {
      console.error('Fehler beim Beenden der Runde:', error);
      throw error;
    }
  },

  // Transaktionshistorie abrufen
  getTransactionHistory: async () => {
    try {
      const response = await api.get('/api/transaction-history/');
      return response;
    } catch (error) {
      console.error('Fehler beim Abrufen der Transaktionshistorie:', error);
      throw error;
    }
  },


  // Einladungslink generieren
  generateInviteLink: async (settings = {}) => {
    try {
      const response = await api.post('/api/generate-invite-link/', settings);
      return response;
    } catch (error) {
      console.error('Fehler beim Generieren des Einladungslinks:', error);
      throw error;
    }
  },

  // Einladungslink einlösen
  redeemInviteLink: async (token) => {
    try {
      const response = await api.post('/api/redeem-invite-link/', {
        token: token
      });
      return response;
    } catch (error) {
      console.error('Fehler beim Einlösen des Einladungslinks:', error);
      throw error;
    }
  },

  // Profil aktualisieren
  updateProfile: async (profileData) => {
    try {
      const response = await api.post('/api/update-profile/', profileData);
      return response;
    } catch (error) {
      console.error('Fehler beim Aktualisieren des Profils:', error);
      throw error;
    }
  },

  // Passwort ändern
  changePassword: async (passwordData) => {
    try {
      const response = await api.post('/api/change-password/', passwordData);
      return response;
    } catch (error) {
      console.error('Fehler beim Ändern des Passworts:', error);
      throw error;
    }
  },

  // Admin: Alle Mitglieder abrufen
  getMembers: async () => {
    try {
      const response = await api.get('/api/admin/members/');
      return response;
    } catch (error) {
      console.error('Fehler beim Abrufen der Mitglieder:', error);
      throw error;
    }
  },

  // Admin: Alle Getränke abrufen
  getDrinks: async () => {
    try {
      const response = await api.get('/api/admin/drinks/');
      return response;
    } catch (error) {
      console.error('Fehler beim Abrufen der Getränke:', error);
      throw error;
    }
  },

  // Admin: Alle Transaktionen abrufen
  getAllTransactions: async () => {
    try {
      const response = await api.get('/api/admin/transactions/');
      return response;
    } catch (error) {
      console.error('Fehler beim Abrufen der Transaktionen:', error);
      throw error;
    }
  },

  // Admin: Mitglied löschen
  deleteMember: async (memberId) => {
    try {
      const response = await api.delete(`/api/admin/members/${memberId}/delete/`);
      return response;
    } catch (error) {
      console.error('Fehler beim Löschen des Mitglieds:', error);
      throw error;
    }
  },

  // Admin: Mitglied Guthaben aktualisieren
  updateMemberBalance: async (memberId, newBalance) => {
    try {
      const response = await api.post(`/api/admin/members/${memberId}/update-balance/`, {
        balance: newBalance
      });
      return response;
    } catch (error) {
      console.error('Fehler beim Aktualisieren des Guthabens:', error);
      throw error;
    }
  },

  // Admin: Mitglied Passwort zurücksetzen
  resetPassword: async (memberId) => {
    try {
      const response = await api.post(`/api/admin/members/${memberId}/reset-password/`);
      return response;
    } catch (error) {
      console.error('Fehler beim Zurücksetzen des Passworts:', error);
      throw error;
    }
  },

  // Admin: Getränk löschen
  deleteDrink: async (drinkId) => {
    try {
      const response = await api.delete(`/api/admin/drinks/${drinkId}/`);
      return response;
    } catch (error) {
      console.error('Fehler beim Löschen des Getränks:', error);
      throw error;
    }
  },

  // Admin: Getränke-Sortierung aktualisieren
  updateDrinkSortOrder: async (drinkOrders) => {
    try {
      const response = await api.post('/api/admin/drinks/update-sort-order/', {
        drink_orders: drinkOrders
      });
      return response;
    } catch (error) {
      console.error('Fehler beim Aktualisieren der Sortierung:', error);
      throw error;
    }
  },

  // Admin: Spende abbrechen
  cancelGift: async (giftId) => {
    try {
      const response = await api.post(`/api/admin/cancel-gift/${giftId}/`);
      return response;
    } catch (error) {
      console.error('Fehler beim Abbrechen der Spende:', error);
      throw error;
    }
  },

  // Eigene Transaktion stornieren
  cancelOwnTransaction: async (transactionId) => {
    try {
      const response = await api.post(`/api/cancel-transaction/${transactionId}/`);
      return response;
    } catch (error) {
      console.error('Fehler beim Stornieren der Transaktion:', error);
      throw error;
    }
  },

  // Admin: Transaktion stornieren
  cancelTransaction: async (transactionId) => {
    try {
      const response = await api.post(`/api/admin/transactions/${transactionId}/cancel/`);
      return response;
    } catch (error) {
      console.error('Fehler beim Stornieren der Transaktion:', error);
      throw error;
    }
  },

  // Einladungslink validieren
  validateInvite: async (token) => {
    try {
      const response = await api.get(`/api/validate-invite/${token}/`);
      return response.data;
    } catch (error) {
      console.error('Fehler bei der Einladungsvalidierung:', error);
      throw error;
    }
  },

  // Registrierung
  register: async (userData) => {
    try {
      const response = await api.post('/api/register/', userData);
      return response.data;
    } catch (error) {
      console.error('Fehler bei der Registrierung:', error);
      throw error;
    }
  },

  // Admin: Icons abrufen
  getIcons: async () => {
    try {
      const response = await api.get('/api/admin/icons/');
      return response;
    } catch (error) {
      console.error('Fehler beim Abrufen der Icons:', error);
      throw error;
    }
  },

  // Admin: Einladungslink erstellen
};

export default api; 